import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux";
import "bootstrap/dist/css/bootstrap.css";

import { BrowserRouter as Router } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleReCaptchaProvider
        reCaptchaKey="6LdbS6onAAAAAFHI37HUUseD5QQwnpFrbq7EDMyg"
        language="en"
        useRecaptchaNet={true}
      >
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </GoogleReCaptchaProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
